import React, { useState } from 'react';
import TextField from 'components/TextField';
import Button from 'components/Button';

const CreateGroup = ({ createGroup }) => {
  const [groupName, setGroupName] = useState('');

  return (
    <>
      <TextField
        fullWidth
        label='Enter Group Name'
        value={groupName}
        onChange={(v) => setGroupName(v)}
      />
      <p
        style={{
          color: 'red',
          fontSize: 16,
          marginBottom: 0,
          fontWeight: 'bold',
        }}>
        Group Name will not be changed after creating the group.
      </p>

      <Button
        title='Create'
        disabled={!groupName}
        containerStyle={{
          backgroundColor: '#000',
          color: '#fff',
          fontWeight: 'normal',
          boxShadow: '4px 4px 20px rgba(0, 0, 0, 0.05)',
          textTransform: 'none',
          borderRadius: '3px',
          fontSize: '16px',
          lineHeight: '1.5',
          width: '100%',
          marginTop: 20,
          opacity: !groupName ? 0.5 : 1,
        }}
        onClick={() => createGroup(groupName)}
      />
    </>
  );
};

export default CreateGroup;
